
const headers = {
    idlanguage: '1',
    token: '9ae5bdc7-e204-4226-9962-13aa32327b6c',
    idchannel: '3',
    idhandset: '5',
    iddevice: 'b5eb2908-5b23-4204-baae-a21358d714e8',
    idusertype: '1',
    idsourceapp: '1',
    timestamp: '1615903405011',
    sessionid: '72f6ec22-8d20-43ca-9b23-a0a313d08e19',
    idrequest: '1015aa57-f356-44df-87de-8a23f7fe4d79'
  };
  export const postOpenfireProfile  = () =>{
    return fetch('/KorekSelfcare/selfcare_portal_realdata/api/Profile/CreateOpenfire', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({})
  })
  .then(response => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then(data => {
      return data; // Return the data as needed
  })
  .catch(err => {
      console.error('Error creating Openfire profile:', err);
      throw err; // Rethrow the error for handling in the caller
  });
  
     
  }
  
  
  
  